module.exports = __webpack_public_path__ + "img/sleepNewLogo.7f728ddd.png";